import React from "react";
import PropTypes from "prop-types";
import isPortal from "../../../common/helpers/isPortal";
import tailwindColors from "../../../../../tailwind.colors";

function UserLink({ userHandle }) {
  return isPortal() ? (
    <div className="tw-bg-blueGray-300 tw-inline-block tw-rounded-full tw-px-1 tw-mx-1 tw-color-blueGray-100">
      {userHandle}
    </div>
  ) : (
    <a
      href={`/profile/${userHandle}`}
      className="tw-bg-blueGray-300 tw-inline-block tw-rounded-full tw-px-1 tw-mx-1 tw-color-blueGray-100"
      target="_blank"
      style={{ color: tailwindColors.blueGray[600] }}
    >
      {userHandle}
    </a>
  );
}

UserLink.propTypes = {
  userHandle: PropTypes.string,
};

UserLink.defaultProps = {
  userHandle: "",
};

export default UserLink;
